import {
  copyTextToClipboard,
  mediaStatusToTextAndColor,
  mediaStatusTooltipText,
} from "@/utils";
import DailymotionIcon from "../../assets/icons/svg/dailymotion-icon.svg?react";
import { toast, Tooltip } from "@/components";
import { MediaModel } from "@/database";
import { trackEvent, getTrackUserContext } from "@/utils/analytics";

export const getContentLocation = () =>
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/discover")
    ? "discover"
    : "content";

export const getPlatformIcon = (platform: string) => {
  switch (platform.toLowerCase()) {
    case "linkedin":
      return { icon: "bi-linkedin", color: "#0077B5" };
    case "instagram":
      return { icon: "bi-instagram", color: "#E4405F" };
    case "twitter":
      return { icon: "bi-twitter", color: "#1DA1F2" };
    case "denmark":
      return { icon: "bi-globe", color: "#000000" };
    case "youtube":
      return { icon: "bi-youtube", color: "red" };
    case "facebook":
      return { icon: "bi-facebook", color: "#1877F2" };
    case "dailymotion":
      return {
        icon: (
          <DailymotionIcon
            width={16}
            height={16}
            style={{ color: "#000000" }}
          />
        ),
        color: "#000000",
      };
    default:
      return { icon: "bi-globe", color: "#000000" };
  }
};

export const handleCopyId = (
  e: React.MouseEvent<HTMLButtonElement>,
  id: string
) => {
  e.preventDefault();
  copyTextToClipboard(id);
  toast.success("Slike ID copied");
};

export const renderStatusBadge = (
  media: MediaModel,
  className: string,
  _text: string
) => (
  <Tooltip content={mediaStatusTooltipText(media?.media_status || 0)}>
    <span className={`badge ${className}`}>
      {mediaStatusToTextAndColor(media?.media_status || 0).statusText}
    </span>
  </Tooltip>
);

export const renderCopyIdSection = (
  media: MediaModel,
  styles: Record<string, string>
) => (
  <Tooltip content="Copy ID">
    <div
      className={`slike-id rounded badge fs-6 mt-2 H ${styles["hover-filter"]}`}
      onClick={async (e) => {
        e.stopPropagation();
        trackEvent("browse", {
          category: "content",
          entity: "Slike ID",
          action: "copy",
          location: getContentLocation(),
          ...getTrackUserContext(),
        });
        await copyTextToClipboard(media.id);
        toast.success("Slike ID copied");
      }}
    >
      {media.id}
    </div>
  </Tooltip>
);
